import React from 'react'
import { Typography } from '@mui/material'
import type { TFunction } from 'i18next'
import { BodyContainer } from './styles'

const DeleteBody: React.FC<{ t: TFunction; text: string }> = ({ t, text }) => (
  <BodyContainer>
    <Typography>{String(t(text))}</Typography>
  </BodyContainer>
)

export default DeleteBody
